// eslint-disable-next-line boundaries/no-unknown-files
import '@radix-ui/themes/styles.css'
import 'antd/dist/antd.css'
import './index.css'

import { createRouter, RouterProvider } from '@tanstack/react-router'
import { GeckoAppKit } from 'app-kit'
import { ErrorFallback } from 'pages/errorFallback/ErrorFallback'
import { NoMatch } from 'pages/noMatch/NoMatch'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Cache, SWRConfig, useSWRConfig } from 'swr'

import { getForecastRuntimeVariables } from '../config'
import { routeTree } from './routeTree.gen'

const runtimeVariables = getForecastRuntimeVariables()

// Create router at module level for type inference and runtime use
const router = createRouter({
  routeTree,
  context: {
    cache: {} as Cache,
  },
  basepath: runtimeVariables.BASE_PATH,
  defaultNotFoundComponent: () => <NoMatch />,
  defaultErrorComponent: ({ error }) => (
    <ErrorFallback reset={() => {}} error={error} />
  ),
})

// This Typescript magic ensures that the route tree's parameter types are
// available everywhere in the app. See:
// https://tanstack.com/router/v1/docs/framework/react/api/router/RegisterType
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// This declaration ensures that runtime variables are appropriately typed
// using similar Typescript magic to the Tanstack router declaration above
declare module 'app-kit' {
  interface GeckoAppConfig {
    runtimeVariables: typeof runtimeVariables
  }
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <GeckoAppKit config={{ appName: 'Forkcast', runtimeVariables }}>
      <SWRConfig value={{ shouldRetryOnError: false, errorRetryCount: 1 }}>
        <Routes />
      </SWRConfig>
    </GeckoAppKit>
  </React.StrictMode>
)

function Routes() {
  const { cache } = useSWRConfig()
  return <RouterProvider router={router} context={{ cache }} />
}
